import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_PROGRAM_ITEM_FORM_REQUEST = `${
  app.NS
}program/save_program_item_form_request`;
export const SAVE_PROGRAM_ITEM_FORM_REQUEST_ACTION = createAction(
  SAVE_PROGRAM_ITEM_FORM_REQUEST
);
const SAVE_PROGRAM_ITEM_FORM_SUCCESS = `${
  app.NS
}program/save_program_item_form_success`;
export const SAVE_PROGRAM_ITEM_FORM_SUCCESS_ACTION = createAction(
  SAVE_PROGRAM_ITEM_FORM_SUCCESS
);
const SAVE_PROGRAM_ITEM_FORM_FAILURE = `${
  app.NS
}program/save_program_item_form_failure`;
export const SAVE_PROGRAM_ITEM_FORM_FAILURE_ACTION = createAction(
  SAVE_PROGRAM_ITEM_FORM_FAILURE
);

export const saveProgramItemFormRequest = id => {
  const action = SAVE_PROGRAM_ITEM_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveProgramItemFormSuccess = user => {
  const action = SAVE_PROGRAM_ITEM_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveProgramItemFormFailure = error => {
  const action = SAVE_PROGRAM_ITEM_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/program_item.js